import { Controller } from '@hotwired/stimulus';

// Messages flash de la page (<template>, layouts/_alerts) : ajoutés à la
// région #toasts, qui reste d'une page à l'autre (data-turbo-permanent) et
// annonce ce qu'elle reçoit ; le modèle est retiré (une page revenue du
// cache ne les rejoue pas). Région cherchée après un court délai : pendant
// le rendu d'une visite, Turbo ne l'a pas encore remise dans la nouvelle
// page ; au premier chargement, elle vient d'apparaître.
export default class extends Controller {
    connect() {
        const messages = this.element.content.cloneNode(true);
        this.element.remove();
        setTimeout(() => document.getElementById('toasts')?.append(messages), 150);
    }
}
